import { DiscountableRisks } from '@/dtos/exceptionalDiscount'

const discountableRiskTypes: number[] = Object.values(DiscountableRisks)

export const isDiscountableRisk = (riskType: number): boolean =>
  discountableRiskTypes.includes(riskType)
